module.exports = __webpack_public_path__ + "img/face_shape_male_extra_rect.8a3d8447.png";